// src/components/Workspace.js
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { removeIndicator, removeMapIndicator } from "../../store/workspaceSlice";
import { useNavigate } from 'react-router-dom';
import LocationFilter from "./LocationFilter";
import { removeSavedCharts } from "../../store/workspaceSlice";
import { CiCircleAlert } from 'react-icons/ci';
import { MdOutlineLocalActivity } from "react-icons/md";
import { setBarConfig, setPieConfig, setStackedConfig, setMapConfig } from "store/mapConfigSlice";
import { setUlgMapConfig } from "store/ulgmapconfigslice";
import { setUseTemproBarChart, setUseUlgMap } from "store/visualizationTypeSlice";
import { setVisualizationType } from "store/visualizationTypeSlice";
import { BiBarChartSquare } from "react-icons/bi";

const Cmn_Workspace = ({ visualize, showWorkspace, setShowWorkspace }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedIndicators, selectedMapFeatures, } = useSelector(
    (state) => state.workspace
  );
  const savedChartsData = useSelector((state) => state.workspace.savedCharts);
  const [showLocationFilter, setShowLocationFilter] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({ show: false, code: null });
  const [deleteValue, setDeleteValue] = useState("indicator");

  console.log("savedChartsDatasavedChartsDatasavedChartsData", savedChartsData)
  const handleRemoveIndicator = (indicatorCode) => {
    const chartsToRemove = savedChartsData.filter(chart =>
      chart.payload?.indicators?.some(ind => ind.i_code === indicatorCode)
    );
    console.log("savedChartsData", savedChartsData)
    console.log("chartsToRemove", chartsToRemove)

    if (chartsToRemove.length > 0) {
      const chartName = chartsToRemove.map(chart => chart.chartName);
      console.log("Charts containing the indicator:", chartName);
      setConfirmDelete({ show: true, code: indicatorCode ,chartName});
      

    } else {
      // Direct delete
      dispatch(removeIndicator(indicatorCode));
    }
    setDeleteValue(null);
  };

  const handleRemoveChart = (chartName) => {
    dispatch(removeSavedCharts(chartName));

  };
  const handleViewChart = (chartName) => {

    const chart = savedChartsData.filter(c => c.chartName === chartName)[0];
    const chartConfigMap = {
      "/temporal-barchart": {
        reduxAction: setBarConfig,
        visualizationType: { value: "bar", label: "Column/ Bar Chart" },
        extra: setUseTemproBarChart
      },
      "/barChart": {
        reduxAction: setBarConfig,
        visualizationType: { value: "bar", label: "Column/ Bar Chart" }
      },
      "/piechart": {
        reduxAction: setPieConfig,
        visualizationType: { value: "pie", label: "Pie / Doughnut Chart" }
      },
      "/stackedcolumnchart": {
        reduxAction: setStackedConfig,
        visualizationType: { value: "stacked", label: "Stacked Chart" }
      },
      "/map-visualization": {
        reduxAction: setMapConfig,
        visualizationType: { value: "map", label: "Map" }
      },
      "/ulg-map-visualization": {
        reduxAction: setUlgMapConfig,
        visualizationType: { value: "map", label: "Map" },
        extra: setUseUlgMap
      }
    };


    const chartConfig = chartConfigMap[chart.path];

    if (chartConfig?.reduxAction) {
      dispatch(chartConfig.reduxAction(chart.reduxPayload));
    }
    if (chartConfig?.extra) {
      dispatch(chartConfig.extra(true));
    }

    if (chartConfig?.visualizationType) {
      dispatch(setVisualizationType({ type: chartConfig.visualizationType.value, label: chartConfig.visualizationType.label }));
    }

    navigate(`${chart.path}`, {
      state: {
        payload: chart.payload,
        // apiResponse: res.data.indicator_values,
        formattedPayload: chart.formattedPayload,
        reduxPayload: chart.reduxPayload
      },
    });
  }


  const geoLevelLabel = (level) => {
    switch (level) {
      case 1: return "National";
      case 2: return "State / UT";
      case 3: return "District";
      case 4: return "ULG";
      default: return "Unknown";
    }
  };
  return (
    <>
      <div
        className="d-flex flex-column border rounded shadow-sm p-1 mb-7"
        style={{ height: "100%", maxHeight: "100vh" }}
      >
        <div
          className="flex-grow-1 p-3"
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#90caf9 #f1f1f1",
          }}
        >
          {/* Indicators Section */}
          <h6 className="fw-bold mb-2 f-14">Indicators</h6>
          {selectedIndicators?.length === 0 ? (
            <div className="alert alert-light text-muted small py-2">
              No indicators selected
            </div>
          ) : (
            <ul className="list-group mb-2 shadow-sm rounded">
              {selectedIndicators?.map((ind, id) => (
                <li
                  key={ind.indicator_code}
                  className="list-group-item d-flex justify-content-between align-items-start"
                  style={{ fontSize: "13px" }}
                >
                  <div>
                    <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
                      {ind.indicator_name && (
                        <>
                          <span>{ind.indicator_name}</span>
                          {ind.dataset_name && <span> ({ind.dataset_name})</span>}
                        </>
                      )}

                      {ind.indicator_date && ind.indicator_date !== "NA" && (
                        <>
                          {" | "}
                          <span
                            style={{
                              backgroundColor: "#2c7ce5",
                              color: "#fff",
                              padding: "0 6px",
                              borderRadius: "4px",
                              fontSize: "12px",
                            }}
                          >
                            {ind.indicator_date}
                          </span>
                        </>
                      )}

                      {ind.agency_name && ind.agency_name !== "NA" && (
                        <>
                          {" | "}
                          <span>{ind.agency_name}</span>
                        </>
                      )}

                      {/* {Array.isArray(ind.geo_levels) && ind.geo_levels.length > 0 && (
                      <>
                        {" | "}
                        <span>{ind.geo_levels.join(", ")}</span>
                      </>
                    )} */}
                    </div>
                    {/* Available Geo Levels Section */}
                    {ind.geo_levels && ind.geo_levels.length > 0 && (
                      <div className="mt-1 mb-1">
                        <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geo Levels:</span>
                        {ind.geo_levels.map((level, idx) => (
                          <span
                            key={idx}
                            style={{
                              backgroundColor: "#28a745",
                              color: "#fff",
                              borderRadius: "0.25rem",
                              padding: "0.2rem 0.5rem",
                              marginRight: "0.3rem",
                              fontSize: "0.75rem",
                              display: "inline-block"
                            }}
                          >
                            {level}
                          </span>
                        ))}
                      </div>
                    )}

                    {ind.indicator_name && (
                      <div className="text-muted small">
                        {[ind.sector_name, ind.sub_sector_name, ind.sub_sub_sector_name]
                          .filter(
                            (val) =>
                              val !== undefined &&
                              val !== null &&
                              val !== "" &&
                              val !== "NA"
                          )
                          .join(" | ")}
                      </div>
                    )}
                  </div>
                  <button
                    className="btn btn-sm btn-outline-danger border-0"
                    onClick={() => handleRemoveIndicator(ind.indicator_code)}
                  >
                    <MdOutlineDeleteOutline size={18} />
                  </button>
                </li>
              ))}
            </ul>
          )}
          <div className="d-flex justify-content-end mb-4">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                navigate('/')
                setShowWorkspace(!showWorkspace)
              }}>
              Add Indicators
            </button>
          </div>

          {/* Locations Section */}
          <h6 className="fw-bold mb-2 f-14">Locations</h6>
          <div className="list-group mb-2 border rounded shadow-sm">
            <div className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <span className="fw-bold">India</span>
                <span className="small text-secondary ms-2">(National)</span>
              </div>
              {/* <small className="text-muted">Default</small> */}
            </div>

            {selectedMapFeatures?.map((data, index) => {
              const locationId = String(data.name || data.properties?.name || '');
              const uniqueKey = `${locationId}-${index}`;
              return (
                <div
                  key={uniqueKey}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div>
                    <span className="fw-bold">{data.properties?.name || data.name}</span>
                    <span className="small text-secondary ms-2">
                      ({geoLevelLabel(data.properties?.geo_level_code || data?.geo_level_code || 4)})
                    </span>
                  </div>
                  <button
                    className="btn btn-sm btn-outline-danger border-0"
                    onClick={() => {
                      dispatch(removeMapIndicator(locationId));
                    }}
                    title="Remove location"
                  >
                    <MdOutlineDeleteOutline size={18} />
                  </button>
                </div>
              );
            })}
          </div>
          <div className="d-flex justify-content-end mb-4">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setShowLocationFilter(true)}>
              Add Location
            </button>
          </div>

          {savedChartsData && savedChartsData.length > 0 && (
            <div className="mb-4">
              <h6 className=" mb-3 fw-bold">
                Charts 
              </h6>
              <div className="list-group border rounded shadow-sm" style={{ maxHeight: '300px', overflow: 'auto' }}>
                {savedChartsData.map((chart, index) => (
                  <div key={index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <div className="mb-1 d-flex justify-content-between align-items-center">
                          <span className="text-dark text-wrap fw-bold">
                            {chart.chartName}
                          </span>
                          <div className="d-flex">
                            <button type="button" onClick={() => handleRemoveChart(chart.chartName)} className="btn btn-sm btn-outline-danger border-0 ms-2 "><MdOutlineDeleteOutline size={18} /></button>
                            <button type="button" onClick={() => handleViewChart(chart.chartName)} className="btn btn-sm btn-outline-primary  ms-2 ">Load</button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>)}
            {/* Visualize Button */}
          <div className="p-2 mb-4 ui-p bg-white border-top">
            <button
              className="btn btn-primary w-100 shadow-sm"
              onClick={() => visualize(selectedIndicators)}
            >
              Visualize
            </button>
          </div>


          {/* Note */}
          <div style={{ fontSize: '0.8rem', color: '#5677fa' }}>
            <p>
              <i>
                Note: Visualization page provides you options to select 'All States / UTs of India', 'All Districts of a State' and 'All ULGs of a District' available per indicator and/or for selected geographies added to the shopping cart.
              </i>
            </p>
          </div>
        </div>

        {/* Location Filter Popup */}
        <LocationFilter
          show={showLocationFilter}
          onClose={() => setShowLocationFilter(false)}
        />
      </div>
      {confirmDelete.show && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            animation: 'fadeIn 0.2s ease-out'
          }}
        >
          <div
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
              borderRadius: '12px',
              padding: '24px',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
              border: '2px solid #3182ce',
              animation: 'scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <CiCircleAlert size={24} style={{ color: '#3182ce' }} />
              <h3 style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#2c5282'
              }}>
                Are you sure?
              </h3>
            </div>

            <p style={{
              margin: '0 0 24px 0',
              fontSize: '14px',
              lineHeight: '1.5',
              color: '#4a5568'
            }}>
              This indicator is used in the below saved charts.<br/>
              {confirmDelete.chartName.map((name, index) => (
                <span key={index} className="text-info fw-bold">{index + 1}. {name}<br/></span>
              ))}
              Deleting it will delete these charts from the workspace. Do you want to proceed?
            </p>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setConfirmDelete({ show: false, code: null })}
                style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)',
                  border: '1px solid #cbd5e0',
                  color: '#4a5568',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '14px',
                  transition: 'all 0.2s',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  dispatch(removeIndicator(confirmDelete.code));
                  confirmDelete.chartName.forEach(name => {
        dispatch(removeSavedCharts(name));
        console.log("Chart removed:", name);
      });
                  setConfirmDelete({ show: false, code: null });
                }}
                style={{
                  background: 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
                  border: 'none',
                  color: 'white',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '14px',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 8px rgba(229, 62, 62, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 6px 12px rgba(229, 62, 62, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 8px rgba(229, 62, 62, 0.3)';
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default Cmn_Workspace;
